module.exports = __webpack_public_path__ + "c70c2376a8e9441b5e521daf9be6a338.obj";


//////////////////
// WEBPACK FOOTER
// ./src/components/Parts/Key3D/keys/key1.obj
// module id = 530
// module chunks = 0